const manageS3 = {
  manageS3: {
    pageTitle: 'S3 관리',
    description: '승인된 스케줄 관리 / AWS S3 링크 전송',
    tabs: {
      pending: '대기중',
      complete: '완료'
    }
  }
};

export default manageS3;